module.exports = __webpack_public_path__ + "img/charging-station-hyper-fast-mobile.d1a0c65c.webp";